import { render, staticRenderFns } from "./search-university.vue?vue&type=template&id=a8a95bb4&scoped=true&"
import script from "./search-university.vue?vue&type=script&lang=js&"
export * from "./search-university.vue?vue&type=script&lang=js&"
import style0 from "./search-university.vue?vue&type=style&index=0&id=a8a95bb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a95bb4",
  null
  
)

export default component.exports